




































































































import { ESearch, Pagination, Scrollbar, SvgImage, TwSelect } from '@/app/components';
import { PlusIcon } from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';

import { OrbitSpinner } from 'epic-spinners';
import { FakeRetrievalQueryCard, RetrievalQueryCard } from '../components';
import { useRetrievalQueries } from '../composable';
import { RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';

export default defineComponent({
    name: 'RetrievalQueries',
    metaInfo: { title: 'Retrieval' },
    components: {
        PlusIcon,
        OrbitSpinner,
        Pagination,
        RetrievalQueryCard,
        FakeRetrievalQueryCard,
        SvgImage,
        Scrollbar,
        TwSelect,
        ESearch,
    },
    setup(props, { root }) {
        const pageSize = 10;
        const searchableFields = [
            {
                label: 'title',
                key: 'title',
                textColorClasses: 'text-primary-700',
                backgroundClasses: 'bg-primary-700',
                highlightClasses: 'bg-primary-300',
                widthClasses: 'pl-16 ml-2',
            },
            {
                label: 'description',
                key: 'description',
                textColorClasses: 'text-teal-700',
                backgroundClasses: 'bg-teal-700',
                highlightClasses: 'bg-teal-300',
                widthClasses: 'pl-28 ml-2',
            },
        ];

        const retrievalQueryStatuses = computed(() => [
            { value: null, label: 'All' },
            ...Object.keys(RetrievalStatus).map((statusLabel: string) => ({
                value: RetrievalStatus[statusLabel],
                label: statusLabel,
            })),
        ]);

        const {
            page,
            query,
            retrievalQueries,
            loading,
            totalResults,
            tab,
            sortBy,
            deleteRetrievalQuery,
            updateCurrentPage,
            sortByChanged,
            setTab,
            sortingFields,
            errors,
        } = useRetrievalQueries(root, 'retrieval', pageSize);

        /** The status of the currently active tab, null when all statuses are shown */
        const statusValue = computed(() => (tab.value === 'all' ? null : tab.value));

        /**
         * Applies the selected status, falling back to the "all" tab when "All" is selected
         * @param value The newly selected status, null when "All" is selected
         */
        const statusChanged = (value: string | null) => setTab(value ?? 'all');

        const deleteQuery = (retrievalQuery: RetrievalQuery) => {
            deleteRetrievalQuery(retrievalQuery)
                .then(() => {
                    (root as any).$toastr.s(`Retrieval Query successfully deleted`, 'Successful deletion!');
                })
                .catch((error) => {
                    (root as any).$toastr.e(error, 'Validation error');
                });
        };

        return {
            tab,
            page,
            pageSize,
            loading,
            retrievalQueries,
            totalResults,
            sortingFields,
            retrievalQueryStatuses,
            statusValue,
            statusChanged,
            query,
            sortBy,
            deleteQuery,
            updateCurrentPage,
            setTab,
            sortByChanged,
            searchableFields,
            errors,
        };
    },
});
